import React, { useState, useEffect, useContext, useRef } from 'react';
import '../../src/assets/css/style.css';
import footer from "../../src/assets/img/mainfooterbg.png"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getCertificateById,  } from "../CertificateService"
import defImg from "../assets/img/download.png"
import { Location } from './LocationContext';
// import { useNavigate } from 'react-router-dom';
import { Link, useSearchParams } from 'react-router-dom';
// import DEFAULT from "../../public/DEFAULT.webp"
import Modal from 'react-modal';
import stateStore from "./Zustand";
import Navbar from "./Navbar";
import ColorRingCustomLoader from "./Loader"
import { useNavigate, useLocation } from 'react-router-dom';
// import Modal from 'react-modal';
import { postOtpVerification } from "../CertificateService";

const ApplicationDetails = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenDecline, setIsOpenDecline] = useState(false);
    const { value, setValue, setValueImage } = stateStore();
    const imageRef = useRef(null)
    const location = useLocation();
    const applicationId = location.state?.applicationId;
    // const location = useContext(Location)
    console.log(location, "location")
    const navigate = useNavigate();
    const [params] = useSearchParams();
    console.log(params.get('id'), "PARAMS")
    const handleCloseDelete = () => setShowDelete(false);
    const [showDelete, setShowDelete] = useState(false);
    const [userData, setUserData] = useState(null);
    // const [certificateById, setCertificateById] = useState(null);
    const [operatorRemarksById, setOperatorRemarksById] = useState(null);
    const [selectedOption, setSelectedOption] = useState('');
    const [remarks, setRemarks] = useState('');
    const [pradhanRemarks, setPradhanRemarks] = useState('');
    const [sendOtp, setSendOtp] = useState(false);
    const [isValidOtp, setIsValidOtp] = useState(true);
    const [otp, setOtp] = useState();
    const [remarksFlag, setRemarksFlag] = useState(false);
    //for bengali write state
    const [aplicantName, setAplicantName] = useState();
    const [relation, setRelation] = useState();
    const [guardianName, setGuardianName] = useState();
    const [relationWithGuardian, setRelationWithGuardian] = useState();
    const [address, setAddress] = useState();
    const [policeStation, setPoliceStation] = useState();
    const [pin, setPin] = useState();
    const [dob, setDob] = useState();
    const [village, setVillage] = useState();
    const [postOffice, setPostOffice] = useState('');

    const [base64String2, setBase64String2] = useState('');
    const [imagePreview2, setImagePreview2] = useState(null);
    const [certificateById, setCertificateById] = useState(
        {
            NAME_APPLI_BEN: '',
            GURDIAN_NM_BEN: '',
            REL_GURDIAN_BEN: '',
            ADDRESS_BEN: '',
            POST_OFFICE_BEN: '',
            POLICE_STATION_BEN: '',
            VILLAGE_BEN: '',
            PIN_BEN: '',
            DOB_BEN: '',

        }
    )
    const [approve, setApprove] = useState("");
    const [reject, setReject] = useState("")

    useEffect(() => {
        const jsonString = localStorage.getItem("Certificate_User");
        const data = JSON.parse(jsonString);
        setUserData(data);
        getAllCertificateList()
        // getOperatorRemarks(data?.Token?.GP_LGD, certificateId.get(`id`)).then(function (result) {
        //     const response = result?.data;
        //     setOperatorRemarksById(response);
        // });
    }, [])


    async function getAllCertificateList() {
        getCertificateById(applicationId).then(function (result) {
            const response = result?.data;
            setCertificateById(response);
            // setAllData(response)
        });
    }
    console.log(operatorRemarksById, "operatorRemarksById")





    const onDocuVerified = (e) => {
        setSelectedOption(e.target.value);
    }
    const onRemarks = (e) => {
        setRemarks(e.target.value)

    }

    const onApp = () => {
        
        setApprove("Approve");
        setIsOpen(true)
    }








    const onOtp = (e) => {
        const value = e.target.value;
        const regex = /^[0-9]{4}$/;
        if (regex.test(value) || value === '') {
            setOtp(value);
            setIsValidOtp(true);
        } else {
            setIsValidOtp(false);
        }
    }
    const onVerifyDecline = () => {
        if (!otp) {
            toast.error("Please Type 4 digit OTP")
        } else {
            postOtpVerification(userData?.Token?.MOBILE, otp, (res) => {
                console.log(res, "koko")
                if (res?.StatusCode == 0) {
                    console.log("hitttttttttt")
                    toast.success("OTP Verified Successfully")
                    setRemarksFlag(true)

                    // navigate("/certificate-list");

                } else {
                    toast.error("Invalid Otp")
                }
            })

        }

    }
    console.log(certificateById?.DIST_CERT, "certificateById?.DIST_CERT")

    const onPradhanRemarks = (e) => {
        setPradhanRemarks(e.target.value)
    }


    const onName = (e) => {
        setAplicantName(e.target.value)
        setCertificateById({ ...certificateById, NAME_APPLI_BEN: e.target.value })

    }

    const onRelationAss = (e) => {
        setRelation(e.target.value)

    }
    const onGuardian = (e) => {
        setGuardianName(e.target.value)
        setCertificateById({ ...certificateById, GURDIAN_NM_BEN: e.target.value })


    }
    const onRelationGuardian = (e) => {
        setRelationWithGuardian(e.target.value)
        setCertificateById({ ...certificateById, REL_GURDIAN_BEN: e.target.value })


    }
    const onAddress = (e) => {
        setAddress(e.target.value)
        setCertificateById({ ...certificateById, ADDRESS_BEN: e.target.value })

    }
    const onPostOffice = (e) => {
        setPostOffice(e.target.value)
        setCertificateById({ ...certificateById, POST_OFFICE_BEN: e.target.value })

    }
    const onPoliceStation = (e) => {
        setPoliceStation(e.target.value)
        setCertificateById({ ...certificateById, POLICE_STATION_BEN: e.target.value })

    }
    const onVillage = (e) => {
        setVillage(e.target.value)
        setCertificateById({ ...certificateById, VILLAGE_BEN: e.target.value })

    }
    const onPin = (e) => {
        setPin(e.target.value)
        setCertificateById({ ...certificateById, PIN_BEN: e.target.value })

    }
    const onDOB = (e) => {
        setDob(e.target.value)
        setCertificateById({ ...certificateById, DOB_BEN: e.target.value })

    }



    const onFile = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64 = reader.result;
                setBase64String2(base64);
                setImagePreview2(base64);
            };
            reader.readAsDataURL(file);
        }
    };
    return (
        <div>
      


   
                      

   
            <ToastContainer />
            <Navbar />
            <div class="grid-container cont sldr">
                <div class="grid-x grid-padding-x" style={{ marginBottom: "20px" }}>
                    <div class="cell tran_div">
                        <h2 style={{ marginLeft: "30px", marginButtom: "40px", color: "orange" }} class="text-center"> Application Form
                            Unique ID - {certificateById?.APPLICATION_ID}</h2>
                    </div>
                    <div class="large-6 medium-12 small-12 cell">
                        <fieldset class="fieldset_class">
                            <legend style={{ color: "#026D7C", fontWeight: "bold" }}>GP Details</legend>
                            <div class="grid-x grid-padding-x">
                                <div class="large-6 medium-12 small-12 cell tran_div">
                                    <div class="input-group">
                                        <span class="input-group-label">District:<span class="impotnt">&nbsp;*</span></span>

                                        <input type="text" ID="txt_assessee_no" placeholder="District" onkeypress="return isNumber(event)" class="input-group-field" value={certificateById?.DIST_NAME} />


                                    </div>
                                </div>
                                <div class="large-6 medium-12 small-12 cell tran_div">
                                    <div class="input-group">
                                        <span class="input-group-label">Block:<span class="impotnt">&nbsp;*</span></span>
                                        <input type="text" ID="txt_assessee_no" placeholder="Block" onkeypress="return isNumber(event)" class="input-group-field" value={certificateById?.BLOCK_NAME} />

                                    </div>
                                </div>
                                <div class="large-6 medium-12 small-12 cell">
                                    <div class="input-group">
                                        <span class="input-group-label">Gram Panchayat:</span>
                                        <input type="text" ID="txt_assessee_no" placeholder="GP" onkeypress="return isNumber(event)" class="input-group-field" value={certificateById?.GP_NAME} />

                                    </div>
                                </div>
                                <div class="large-6 medium-12 small-12 cell" id="Div1" >
                                    <div class="input-group">
                                        <span class="input-group-label">Sansad:<span class="impotnt">&nbsp;*</span></span>
                                        <input type="text" ID="txt_assessee_no" placeholder="Sansad" onkeypress="return isNumber(event)" class="input-group-field" value={certificateById?.SANSAD_NO_RM} />

                                    </div>
                                </div>
                                <div class="large-6 medium-12 small-12 cell" id="Div2" >
                                    {/* <input type="text" ID="txt_assessee_no" placeholder="Assessee No" onkeypress="return isNumber(event)" class="input-group-field" /> */}
                                    <div class="input-group">
                                        <span class="input-group-label">Assessee No:</span>
                                        <input type="text" ID="txt_assessee_no" placeholder="Assessee No" onkeypress="return isNumber(event)" class="input-group-field" value={certificateById?.ASSESSEE_NO} />
                                    </div>
                                </div>
                                <div class="large-6 medium-12 small-12 cell" id="Div4" >
                                    <div class="input-group">
                                        <span class="input-group-label">Assessee Name:</span>
                                        <input type="text" id="txt_assessee_name" placeholder="Assessee Name" class="input-group-field" value={certificateById?.ASSESSEE_NAME} />
                                    </div>
                                </div>
                                <div class="large-6 medium-12 small-12 cell" id="Div5" >
                                    <div class="input-group">
                                        <span class="input-group-label">Relation with Assessee:</span>
                                        <input type="text" id="txt_assessee_rel" placeholder="Relation with Assessee" class="input-group-field" value={certificateById?.RELT_ASS} />
                                    </div>
                                </div>


                            </div>
                        </fieldset>
                       
                            <div class="large-12 medium-12 small-12 cell">
                                <fieldset class="fieldset_class">
                                    <legend style={{ color: "#026D7C", fontWeight: "bold" }}>Applicant Details</legend>
                                    <div class="grid-x grid-padding-x">

                                        <div class="large-6 medium-12 small-12 cell" id="Div3" >
                                            <div class="input-group">
                                                <span class="input-group-label">Applicant Name:<span class="impotnt">&nbsp;*</span></span>
                                                <input type="text" id="txt_applicant_name" placeholder="Applicant Name" class="input-group-field" value={certificateById?.NAME_APPLI} />
                                            </div>
                                        </div>
                                        <div class="large-6 medium-12 small-12 cell" id="Div5" >
                                            <div class="input-group">
                                                <span class="input-group-label">Gender:<span class="impotnt">&nbsp;*</span></span>
                                                <input type="text" id="txt_assessee_rel" placeholder="Gender" class="input-group-field" value={certificateById?.GENDER} />
                                            </div>
                                        </div>
                                        <div class="large-6 medium-12 small-12 cell" id="Div11" >
                                            <div class="input-group">
                                                <span class="input-group-label">Guardian Name:<span class="impotnt">&nbsp;*</span></span>
                                                <input type="text" id="txt_guardian" placeholder="Relation with Assessee" class="input-group-field" value={certificateById?.GURDIAN_NM} />
                                            </div>
                                        </div>
                                        <div class="large-6 medium-12 small-12 cell" id="Div12" >
                                            <div class="input-group">
                                                <span class="input-group-label">Relation with Guardian:<span class="impotnt">&nbsp;*</span></span>
                                                <input type="text" ID="txt_assessee_no" placeholder="Relation" onkeypress="return isNumber(event)" class="input-group-field" value={certificateById?.REL_GURDIAN} />

                                            </div>
                                        </div>
                                        <div class="large-6 medium-12 small-12 cell" id="Div6" >
                                            <div class="input-group">
                                                <span class="input-group-label">Address:<span class="impotnt">&nbsp;*</span></span>

                                                <input type="text" id="txt_addr" placeholder="Address" class="input-group-field" value={certificateById?.ADDRESS} />

                                            </div>
                                        </div>
                                        <div class="large-6 medium-12 small-12 cell" id="Div6" >
                                            <div class="input-group">
                                                <span class="input-group-label">Post Office:<span class="impotnt">&nbsp;*</span></span>

                                                <input type="text" id="txt_addr" placeholder="Post Office" class="input-group-field" value={certificateById?.POST_OFFICE} />

                                            </div>
                                        </div>
                                        <div class="large-6 medium-12 small-12 cell" id="Div7" >
                                            <div class="input-group">
                                                <span class="input-group-label">Police Station:<span class="impotnt">&nbsp;*</span></span>

                                                <input type="text" id="txt_habitation" placeholder="Police Station" class="input-group-field" value={certificateById?.POLICE_STATION} />

                                            </div>
                                        </div>
                                        <div class="large-6 medium-12 small-12 cell">
                                            <div class="input-group">
                                                <span class="input-group-label">Village:<span class="impotnt">&nbsp;*</span></span>
                                                <input type="text" ID="txt_assessee_no" placeholder="Village" onkeypress="return isNumber(event)" class="input-group-field" value={certificateById?.VILLAGE} />
                                            </div>
                                        </div>

                                        <div class="large-6 medium-12 small-12 cell" id="Div8" >
                                            <div class="input-group">
                                                <span class="input-group-label">PIN:<span class="impotnt">&nbsp;*</span></span>

                                                <input type="text" id="txt_pin" placeholder="Pin" onkeypress="return isNumber(event)" class="input-group-field" maxLength={6} value={certificateById?.PIN} />

                                            </div>
                                        </div>
                                        <div class="large-6 medium-12 small-12 cell" id="Div13" >
                                            <div class="input-group">
                                                <span class="input-group-label">DOB:<span class="impotnt">&nbsp;*</span></span>

                                                <input type="text" id="txt_dob" placeholder="DOB" textmode="Date" class="input-group-field" value={certificateById?.DOB} />
                                            </div>
                                        </div>



                                    </div>
                                </fieldset>
                            </div> 
                                                
                    </div>

                    <div class="large-6 medium-12 small-12 cell">
                        <fieldset class="fieldset_class">
                            <legend style={{ color: "#026D7C", fontWeight: "bold" }}>Certificate Applied For</legend>
                            <div class="grid-x grid-padding-x">
                                <div class="large-12 medium-12 small-12 cell tran_div">
                                    <div>
                                        <span class="input-group-label">Certificate Type:<span class="impotnt">&nbsp;*</span></span>
                                    </div>
                                    <div className="large-12 medium-12 small-12 cert-type">
                                        <ul>
                                            {certificateById?.CHAR_CERT === "-" ? "" : <li>{certificateById?.CHAR_CERT}</li>}
                                            {certificateById?.INCM_CERT === "-" ? "" : <li>{certificateById?.INCM_CERT}</li>}
                                            {certificateById?.RESI_CERT === "-" ? "" : <li>{certificateById?.RESI_CERT}</li>}
                                            {certificateById?.SPER_CERT === "-" ? "" : <li>{certificateById?.SPER_CERT}</li>}
                                            {certificateById?.DIST_CERT === "-" ? "" : <li>{certificateById?.DIST_CERT}</li>}
                                            {certificateById?.CAST_CERT === "-" ? "" : <li>{certificateById?.CAST_CERT}</li>}
                                            {certificateById?.UNMARRIED_CERT === "-" ? "" : <li>{certificateById?.UNMARRIED_CERT}</li>}

                                            {/* <div className="clearfix"></div> */}
                                        </ul>

                                    </div>
                                </div>
                                {certificateById?.INCM_CERT === "Income Certificate including Character\r\n" ?

                                    <>
                                        <div className='cell large-12' style={{ marginBottom: "10px" }}>
                                            <fieldset class="fieldset_class cell" style={{ marginBottom: "10px" }}>
                                                <legend style={{ color: "#026D7C", fontWeight: "bold", marginBottom: "0px" }}>Income Certificate</legend>
                                                <div className='grid-x grid-margin-x'>
                                                    <div class="large-6 medium-12 small-12 cell" id="Div9" >
                                                        <div class="input-group">
                                                            <span class="input-group-label">Source of Income:<span class="impotnt">&nbsp;*</span></span>

                                                            <input type="text" id="txt_mobile" placeholder="Source of Income" onkeypress="return isNumber(event)" class="input-group-field" value={certificateById?.INCM_SOURCE} />

                                                        </div>

                                                    </div>
                                                    <div class="large-6 medium-12 small-12 cell" id="Div9" >
                                                        <div class="input-group">
                                                            <span class="input-group-label">Annual Income of Family:<span class="impotnt">&nbsp;*</span></span>

                                                            <input type="text" id="txt_mobile" placeholder="Annual Income of Family" onkeypress="return isNumber(event)" class="input-group-field" value={certificateById?.INCM_ANNUAL} />

                                                        </div>

                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </> : ""
                                }

                                {certificateById?.DIST_CERT === "Distance Certificate" ?

                                    <>
                                        <div className='cell large-12' style={{ marginBottom: "10px" }}>
                                            <fieldset class="fieldset_class cell" style={{ marginBottom: "10px" }}>
                                                <legend style={{ color: "#026D7C", fontWeight: "bold", marginBottom: "0px" }}>Distance Certificate</legend>
                                                <div className='grid-x grid-margin-x'>
                                                    <div class="large-6 medium-12 small-12 cell" id="Div9" >
                                                        <div class="input-group">
                                                            <span class="input-group-label">Distance From Residential (KM):<span class="impotnt">&nbsp;*</span></span>

                                                            <input type="text" id="txt_mobile" placeholder="Distance" onkeypress="return isNumber(event)" class="input-group-field" value={certificateById?.RESI_DISTANCE} />

                                                        </div>

                                                    </div>

                                                    <div class="large-6 medium-12 small-12 cell" id="Div9" >
                                                        <div class="input-group">
                                                            <span class="input-group-label">Location:<span class="impotnt">&nbsp;*</span></span>

                                                            <input type="text" id="txt_mobile" placeholder="Location" onkeypress="return isNumber(event)" class="input-group-field" value={certificateById?.RESI_LOCATION} />

                                                        </div>

                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </> : ""
                                }

                                {certificateById?.CAST_CERT === "Caste Certificate" ?
                                    <div className='cell large-12' style={{ marginBottom: "10px" }}>
                                        <fieldset class="fieldset_class cell" style={{ marginBottom: "10px" }}>
                                            <legend style={{ color: "#026D7C", fontWeight: "bold", marginBottom: "0px" }}>Caste Certificate</legend>
                                            <div className='grid-x grid-margin-x'>
                                                <div class="large-3 medium-6 small-6 cell tran_div">
                                                    <div class="input-group">
                                                        <span class="input-group-label">Religion:<span class="impotnt">&nbsp;*</span></span>
                                                        <input type="text" id="txt_mobile" placeholder="Religion" onkeypress="return isNumber(event)" class="input-group-field" value={certificateById?.RELIGION} />
                                                    </div>
                                                </div>
                                                <div class="large-3 medium-6 small-6 cell tran_div">
                                                    <div class="input-group">
                                                        <span class="input-group-label">Caste:<span class="impotnt">&nbsp;*</span></span>
                                                        <input type="text" id="txt_mobile" placeholder="Caste" onkeypress="return isNumber(event)" class="input-group-field" value={certificateById?.CAST} />
                                                    </div>
                                                </div>


                                                <div class="large-6 medium-12 small-12 cell tran_div">
                                                    <div class="input-group">
                                                        <span class="input-group-label">Sub Caste:<span class="impotnt">&nbsp;*</span></span>
                                                        <input type="text" id="txt_mobile" placeholder="Sub Caste" onkeypress="return isNumber(event)" class="input-group-field" value={certificateById?.SUB_CAST} />
                                                    </div>


                                                </div>

                                            </div>

                                        </fieldset>
                                    </div> : ""}

                                {certificateById?.SPER_CERT === "Same Person Certificate\r\n" ?
                                    <div className='cell large-12' style={{ marginBottom: "10px" }}>
                                        <fieldset class="fieldset_class cell" style={{ marginBottom: "10px" }}>
                                            <legend style={{ color: "#026D7C", fontWeight: "bold", marginBottom: "0px" }}>Same Person Certificate</legend>
                                            <div className='grid-x grid-margin-x'>
                                                <div class="large-12 medium-12 small-12 cell" id="Div9" >
                                                    <div class="input-group">
                                                        <span class="input-group-label">Same Person Old name:<span class="impotnt">&nbsp;*</span></span>

                                                        <input type="text" id="txt_mobile" placeholder="Same Person Old name" onkeypress="return isNumber(event)" class="input-group-field" value={certificateById?.SPER_OLD_NAME} />

                                                    </div>
                                                    <div class="input-group">
                                                        <span class="input-group-label">Same Person Current name:<span class="impotnt">&nbsp;*</span></span>

                                                        <input type="text" id="txt_mobile" placeholder="Same Person Current name" onkeypress="return isNumber(event)" class="input-group-field" value={certificateById?.SPER_CURR_NAME} />

                                                    </div>

                                                </div>
                                            </div>
                                        </fieldset>
                                    </div> : ""}
                                <div class="large-6 medium-12 small-12 cell" id="Div9" >
                                    <div class="input-group">
                                        <span class="input-group-label">Mobile No:<span class="impotnt">&nbsp;*</span></span>

                                        <input type="text" id="txt_mobile" placeholder="Mobile No" onkeypress="return isNumber(event)" class="input-group-field" value={certificateById?.MOBILE_NO} />

                                    </div>

                                </div>
                                <div class="large-6 medium-12 small-12 cell" id="Div10" >
                                    <div class="input-group">
                                        <span class="input-group-label">Whatsapp No:</span>

                                        <input maxLength={10} type="text" id="txt_whatsapp" placeholder="Whatsapp No" onkeypress="return isNumber(event)" class="input-group-field" value={certificateById?.WHATSAPP_NO} />

                                    </div>

                                </div>
                                <div class="large-12 medium-12 small-12 cell" id="Div14" >
                                    <div class="input-group">
                                        <span class="input-group-label">Email:</span>

                                        <input type="text" id="txt_email" placeholder="Email" class="input-group-field" value={certificateById?.EMAIL} />

                                    </div>
                                </div>

                                <div className='large-12 medium-12 small-12 cell'>
                                    <div className='grid-x grid-margin-x'>
                                        <div className='large-4 medium-4 small-12 cell'>
                                            <span class="input-group-label">Document 1:<span class="impotnt">&nbsp;*</span></span>

                                            <input type="text" ID="txt_assessee_no" placeholder="Document" onkeypress="return isNumber(event)" class="input-group-field" value={certificateById?.DOC_TYPE1} />

                                        </div>
                                        <div className='large-3 medium-3 small-12 cell'>
                                            <span class="input-group-label">Document Number:<span class="impotnt">&nbsp;*</span></span>

                                            <input type='text' placeholder='Document Number' name='docUniqueNo' value={certificateById?.DOC_NO1} />
                                        </div>
                                        <div className='large-5 medium-5 small-12 cell'>
                                            <span class="input-group-label">View Document<span class="impotnt">&nbsp;*</span></span>
                                            <Link target='blank' to={`https://api.wbpms.in/${certificateById?.link1}`} style={{ color: "black" }}><i class="fa fa-solid fa-eye fa-xl" style={{ marginTop: "15px" }}></i></Link>
                                        </div>

                                    </div>
                                    <div className='grid-x grid-margin-x'>
                                        <div className='large-4 medium-4 small-12 cell'>
                                            <span class="input-group-label">Document 2:<span class="impotnt">&nbsp;*</span></span>

                                            <input type="text" ID="txt_assessee_no" placeholder="Document" onkeypress="return isNumber(event)" class="input-group-field" value={certificateById?.DOC_TYPE2} />
                                        </div>
                                        <div className='large-3 medium-3 small-12 cell'>
                                            <span class="input-group-label">Document Number:<span class="impotnt">&nbsp;*</span></span>

                                            <input type='text' placeholder='Document Number' name='docUniqueNo' value={certificateById?.DOC_NO2} />
                                        </div>
                                        <div className='large-5 medium-5 small-12 cell'>
                                            <span class="input-group-label">View Document<span class="impotnt">&nbsp;*</span></span>

                                            <Link target='blank' to={`https://api.wbpms.in/${certificateById?.link2}`} style={{ color: "black" }}><i class="fa fa-solid fa-eye fa-xl" style={{ marginTop: "15px" }}></i></Link>

                                        </div>

                                    </div>

                                    <div className='grid-x grid-margin-x'>


                                        <div className='large-4 medium-5 small-12 cell'>
                                            <span class="input-group-label">Applicant Photo<span class="impotnt">&nbsp;*</span></span>

                                            <Link target='blank' to={`https://api.wbpms.in/${certificateById?.APPLICANT_IMG_LINK}`} style={{ color: "black" }}><i class="fa fa-solid fa-eye fa-xl" style={{ marginTop: "15px" }}></i></Link>

                                        </div>

                                    </div>
                                </div>



                            </div>
                        </fieldset>           
                         
                                    
                           
                      


                    
                    </div>
                </div>

            </div>

            <nav className="footer" style={{ marginTop: "120px" }}>
                <img src={footer} />
                <p className="text-center lastp" style={{ fontSize: "26px !important" }}><strong>©</strong>
                    2024 Designed and Developed By <b>IT And Statistical Cell,</b> Panchayat & Rural
                    Development Department <b>Govt. of West Bengal</b>
                </p>
                <p className="text-center lastp" style={{ fontSize: "26px !important" }}>Site best viewed with 1920x1080 resolution in
                    Google Chrome 31.0.1650.63, Firefox 55.0.2, Safari 5.1.7 & IE 11.0 and above</p>
            </nav>
        </div>
    )
}

export default ApplicationDetails;